
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'
import { StartFlex, ColumnFlex, BetweenFlex, IconFont, Button, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { OnlineStatus } from "~widgets/online-status"

interface MemberListItemProps {
  member: any
  onItemClick?: (m: any)  => void
  selecteds?: any[]
  isSelectMode?: boolean
  isLastItem?: boolean
}
const MemberListItem: React.FC<MemberListItemProps> = ({
  member,
  isSelectMode,
  isLastItem,
  selecteds,
  onItemClick,
}) => {
  const theme = useTheme()
  const checked = selecteds?.includes(member.user_id)
  return (
    <StartFlex width="100%">
      <Button
        flexDirection="row"
        width="100%"
        padding="0 12px"
        bg={theme.colors.blockBackground}
        onClick={() => onItemClick?.(member)}
      >
        <Avatar size={40} avatar={member.user.avatar} name={member.user.name} />
          <BetweenFlex
            flex={1}
            padding="15px 0"
            ml="10px"
            style={{
              borderBottomWidth: StyleSheet.hairlineWidth,
              borderBottomColor: isLastItem ? "transparent" : theme.colors.border,
              borderBottomStyle: "solid"
            }}
          >
            <ColumnFlex>
              <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600" mb="3px">{member.user.name}</Text>
              <OnlineStatus last_seen={member.user.last_seen} online={member.user.online} />
            </ColumnFlex>
            {isSelectMode && <IconFont name={checked ? "cg" : "yuan"} size={15} color={checked ? theme.colors.primary : theme.colors.border} />}
          </BetweenFlex>
        
      </Button>
    </StartFlex>
    
  )
}

export default MemberListItem
